<template>
  <v-app>
    <template v-if="!$route.meta.public">
      <v-app-bar app color="primary" dark>
        <v-app-bar-nav-icon
          class="hidden-md-and-up"
          @click="drawer = true"></v-app-bar-nav-icon>
        <v-toolbar-title>
          <router-link to="/">
            <v-img
              lazy-src="https://picsum.photos/id/11/10/6"
              max-width="160"
              src="/img/logo-horizontal-branco.png"></v-img>
          </router-link>
        </v-toolbar-title>
        <v-toolbar-items class="hidden-sm-and-down ml-lg-9">
          <template>
            <v-btn to="/reservas" text>Reservas</v-btn>
          </template>
          <v-btn to="/salas" text>Salas</v-btn>
          <template v-if="isAdministrador">
            <v-btn to="/blocos" text>Blocos</v-btn>
          </template>
          <template v-if="isAdministrador">
            <v-btn to="/relatorios" text>Relatórios</v-btn>
          </template>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <div class="ml-lg-9 hidden-sm-and-down">
          Olá, {{ nome }}
          <v-menu
            offset-y
            origin="center center"
            :nudge-bottom="10"
            transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                large
                text
                slot="activator"
                v-on="on"
                class="hidden-xs-only">
                <v-avatar size="30px">
                  <v-icon>account_circle</v-icon>
                </v-avatar>
              </v-btn>
            </template>
            <v-list class="pa-0">
              <v-list-item @click="to('/dadosPessoais')">
                <v-list-item-icon>
                  <v-icon>face</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Dados Pessoais</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="to('/logout')">
                <v-list-item-icon>
                  <v-icon>power_settings_new</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Sair</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" absolute temporary app>
        <v-list-item @click="to('/dadosPessoais')">
          <v-list-item-icon>
            <v-icon>face</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Dados Pessoais</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-spacer></v-spacer>
        <v-list nav dense>
          <v-list-item-group
            v-model="group"
            active-class="deep-purple--text text--accent-4">
            <v-list-item>
              <v-list-item-title
                ><router-link to="/">Reservas</router-link></v-list-item-title
              >
            </v-list-item>

            <template v-if="isAdministrador">
              <v-list-item>
                <v-list-item-title
                  ><router-link to="/salas"
                    >Salas</router-link
                  ></v-list-item-title
                >
              </v-list-item>

              <v-list-item>
                <v-list-item-title
                  ><router-link to="/blocos"
                    >Blocos</router-link
                  ></v-list-item-title
                >
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>

        <template v-slot:append>
          <div class="pa-2">
            <v-btn block color="primary" to="/logout">
              <v-icon>power_settings_new</v-icon> Sair
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>

      <v-main>
        <router-view></router-view>
      </v-main>

      <!-- App Footer -->
      <v-footer class="white pa-3" app>
        <span class="caption"
          >Núcleo de Práticas em Informática &copy;
          {{ new Date().getFullYear() }} - ReservAqui v{{ ultimaVersao }}</span
        >
      </v-footer>
    </template>

    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>

    <v-snackbar top right v-model="snackbar" :color="tipo" :timeout="3000">
      {{ mensagem }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-model="visivel"
      width="auto"
      height="auto"
      @click:outside="close">
      <v-card class="mt-3 pa-4" outlined>
        <button class="float-right" @click="close">
          <v-icon color="primary">close</v-icon>
        </button>

        <v-card-title class="flex-column primary--text font-weight-bold">
          <v-icon size="100" color="primary">info</v-icon>
          <p>Novidades da versão {{ ultimaVersao }}</p>
        </v-card-title>

        <v-card-text>
          <ul>
            <li v-for="(novidade, i) in novidades" :key="i">
              {{ novidade }}
            </li>
          </ul>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn class="text-capitalize" outlined color="primary" @click="close"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  name: "App",
  data: () => ({
    ultimaVersao: "1.2.0",
    versaoAtual: localStorage.getItem("versao"),
    novidades: [
      "A funcionalidade de gerar o relatório semanal de reservas",
      "O motivo do indeferimento é enviado por email",
      "É possível consultar o motivo de um indeferimento no sistema",
      "Navegação por meio do botão de voltar",
      "É possível ver o responsável pela reserva no calendário",
    ],
    drawer: null,
    group: null,
  }),
  computed: {
    ...mapGetters({
      isAdministrador: ["auth/isAdministrador"],
      isPrefeitura: ["auth/isPrefeitura"],
      nome: ["auth/username"],
      mensagem: ["message/mensagem"],
      tipo: ["message/tipo"],
    }),
    snackbar: {
      get: function () {
        return this.mensagem !== null
      },
      set: function (value) {
        if (!value) {
          this.limparMensagem()
        }
      },
    },
    visivel() {
      return this.ultimaVersao != this.versaoAtual
    },
  },

  watch: {
    mensagem() {
      this.snackbar = true
    },
  },

  methods: {
    logout() {
      this.$router.push("/logout")
    },
    to(path) {
      this.$router.push(path)
    },
    close() {
      this.versaoAtual = this.ultimaVersao
      localStorage.setItem("versao", this.ultimaVersao)
    },
    ...mapActions("message", ["limparMensagem"]),
  },
}
</script>
